import React from "react";
import styles from "./blur-overlay.module.scss";
import { PrimaryBtn } from "../button/primary-button";

const BlurOverlay = ({
  message,
  redirectPath,
  buttonText = "Continue",
  customClass = "",
  onButtonClick,
  buttonProps = {},
  buttons,
}) => {
  const {
    customClass: sharedButtonClass = "",
    onClick: sharedOnClick,
    title: sharedTitle,
    ...sharedButtonProps
  } = buttonProps || {};

  const handleButtonAction = (event, fallbackRedirectPath, clickHandler) => {
    if (event?.preventDefault) {
      event.preventDefault();
    }

    if (clickHandler) {
      clickHandler(event);
      return;
    }

    if (fallbackRedirectPath && typeof window !== "undefined") {
      window.location.href = fallbackRedirectPath;
    }
  };

  const renderMessage = () => {
    if (!message) {
      return null;
    }

    if (typeof message === "string") {
      return <p className={`${styles.message} text-center`}>{message}</p>;
    }

    return (
      <div className={`${styles.message} text-center`}>
        {React.isValidElement(message) ? message : <>{message}</>}
      </div>
    );
  };

  const renderButtons = () => {
    if (Array.isArray(buttons) && buttons.length) {
      const validButtons = buttons.filter(Boolean);

      if (!validButtons.length) {
        return null;
      }

      return validButtons.map((button = {}, index) => {
        const {
          title,
          text,
          variant = "primary",
          redirectPath: buttonRedirectPath,
          onClick: buttonOnClick,
          customClass: buttonCustomClass = "",
          buttonProps: perButtonProps = {},
          id,
          ...restButtonConfig
        } = button;

        const buttonTitle = title || text || sharedTitle || buttonText;
        const {
          customClass: nestedCustomClass = "",
          onClick: nestedOnClick,
          title: nestedTitle,
          ...otherPerButtonProps
        } = perButtonProps;

        const mergedCustomClass = [
          variant === "secondary" ? "admy-outline-btn" : "",
          sharedButtonClass,
          buttonCustomClass,
          nestedCustomClass,
        ]
          .filter(Boolean)
          .join(" ");

        const key = id || `${buttonTitle || sharedTitle || "blur-overlay-btn"}-${index}`;

        return (
          <PrimaryBtn
            key={key}
            title={buttonTitle}
            customClass={mergedCustomClass}
            onClick={(event) =>
              handleButtonAction(
                event,
                buttonRedirectPath,
                buttonOnClick || nestedOnClick
              )
            }
            {...sharedButtonProps}
            {...restButtonConfig}
            {...otherPerButtonProps}
          />
        );
      });
    }

    return (
      <PrimaryBtn
        title={sharedTitle || buttonText}
        customClass={sharedButtonClass}
        onClick={(event) =>
          handleButtonAction(event, redirectPath, onButtonClick || sharedOnClick)
        }
        {...sharedButtonProps}
      />
    );
  };

  return (
    <div className={`${styles.blurOverlay} ${customClass}`}>
      <div className={styles.overlayContent}>
        <div className={styles.messageContainer}>
          {renderMessage()}

          <div className={styles.buttonContainer}>{renderButtons()}</div>
        </div>
      </div>
    </div>
  );
};

export default BlurOverlay;
